import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './pages/Layout';
import HerLayout from './pages/her/Layout';
import Menu from './pages/Menu';
import Uwu from './pages/her/Uwu';
import Bok from './pages/her/Bok';
import Error from './pages/Error';

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path='/' element={<Layout />}>
          <Route index element={<Error />} />
          <Route path='menu' element={<Menu />} />
          <Route path='uwu' element={<Navigate to='/her/uwu' replace />} />
          <Route path='bok' element={<Navigate to='/her/' replace />} />
          <Route path='*' element={<Error />} />
        </Route>

        <Route path='/her' element={<HerLayout />}>
          <Route index element={<Bok />} />
          <Route path='uwu' element={<Uwu />} />
          <Route path='bok' element={<Bok />} />
          <Route path='*' element={<Error />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}